<template>
  <tr>
    <td class="align-middle">
      <img class="border border-secondary rounded mr-3" :src="profilePic" width="75" height="75">
      <router-link :to="'/thinktank-user/' + name.slug"  v-if="name.slug !== '#'">{{name.name}}</router-link>
      <span v-else>{{ name.name }}</span>
    </td>
    <!--td class="align-middle"><a class="listLink" v-for="category in categories" v-bind:key="category.id" href="#">{{category.name}}</a></td-->
    <td class="align-middle"><a class="listLink" v-for="category in categories.filter(category => category.name !== 'VE Awards')" v-bind:key="category.id" href="#"> {{ category.name }} </a></td>
    <td class="align-middle" v-if="(type === 'sent') && canShowStatus"><!--{{statuspending}} -->
      <router-link :to="getRouterLink(id)">  {{ statuspending }}</router-link>
    </td>
    <td class="align-middle" v-if="type === 'received' && canShowStatus">
      <span v-if="!acceptedDeclined"><router-link :to="'/my-profile/review-nomination/' + id">Accept</router-link> |</span>
      <span v-if="!acceptedDeclined"><router-link :to="'/my-profile/review-nomination/' + id">Decline</router-link> |</span>
      <div v-if="categories[0]['name'] == 'High5'" class="">
        <a :href='linkHigh5' target='_blank'>View PDF</a>
      </div>
      <div v-else>
        <router-link :to="getRouterLink(id)"> {{statuspending}}</router-link>
      </div>
    </td>
    <td class="align-middle" v-if="type === 'review' && canShowStatus">
      <router-link :to="status[0]" v-if="status[0] !== '#'">{{ status[1] }} (Accept/Reject/Downgrade)</router-link>
      <span v-else>{{ status[1] }}</span>
    </td>
    <td class="align-middle" v-if="type === 'hrbp' && canShowStatus">
      <router-link :to="getRouterLink(id)" v-if="status[0] !== '#'">{{ status[1] }}</router-link>
      <span v-else>{{ status[1] }}</span>
    </td>
    <td class="align-middle" v-if="type === 'EmployeeAward' && canShowStatus">
      <router-link :to="status[0]" v-if="status[0] !== '#'">{{ status[1] }} (Accept/Reject)</router-link>
      <span v-else>{{ status[1] }}</span>
    </td>
    <td class="align-middle" v-if="type === 'review' && canShowStatus">
      <router-link :to="downgradeStatus" v-if="status[0] !== '#'">Downgrade to High5</router-link>
      <span v-else>{{ status[1] }}</span>
    </td>
    <td v-if="!canShowStatus">-</td>
  </tr>
</template>

<script>
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
export default {
  props: [
    'id',
    'name',
    'categories',
    'status',
    'downgradeStatus',
    'profilePic',
    'type',
    'statuspending'
  ],
  computed: {
    acceptedDeclined: function () {
      return this.status !== 'Pending'
    }
  },
  data () {
    return {
      canShowStatus: false,
      linkHigh5: ''
    }
  },
  created () {
    if (this.$route.name === 'My profile' || this.$route.name === 'Report VE Awards') {
      this.canShowStatus = true
    }
    if (this.type === 'sent' || this.type === 'received') {
      console.log(this.type, ' type ', this.statuspending, ' statuspending ')
      if (this.statuspending === 'Approve') {
        this.statuspending = 'Approved'
      }
      if (this.statuspending === 'Reject') {
        this.statuspending = 'Rejected'
      }
      if (this.statuspending === '') {
        this.statuspending = 'Pending'
      }
      console.log(this.type, ' type ', this.statuspending, ' statuspending ')
    }
    console.log(' status ', this.status)
    if (this.type === 'review') {
      // Split the status string
      var parts = this.status[0].split('/')
      // Get the last value
      var lastValue = parts[parts.length - 1]
      console.log('Last value:', lastValue)
      let filterNames = ["On the Spot", "Teams"]
      // Filter the array to keep only records with names in filterNames
      console.log('inside review before filter ', this.categories)
      this.categories = this.categories.filter(category => filterNames.includes(category.name))
      console.log('inside review after filter ', this.categories)
    }
    if (this.type === 'EmployeeAward') {
      let filterNames = ["Team of the Month", "Employee of the Month","Regional Employee of the Month"]
      // Filter the array to keep only records with names in filterNames
      this.categories = this.categories.filter(category => filterNames.includes(category.name))
    }
    if (this.categories[0]['name'] === 'High5' && this.type !== 'hrbp' && this.type !== 'review')
      this.getLinkURI(this.id)
    // Assuming categories is a reactive data property in your Vue component
    this.categories = this.categories.filter(category => category.name !== 'VE Awards')
    console.log('inside review after filter ', this.categories)  
  },
  methods: {
    getRouterLink: function(id) {
      let link = '/my-profile/review-nomination/' + id
      console.log(' getRouterLink ', this.categories)
      this.categories.forEach(category => {
        if (category && category.name && (category.name === "Employee of the Month" || category.name === "Team of the Month" || category.name === "Regional Employee of the Month")) {
          link = '/my-profile/review-nomination-employee-award/' + id
        }
        if (category && category.name && category.name === "Employee Award - BU Employee of the Year") {
          link = '/my-profile/review-nomination-bu-employee-award/' + id
        }
        if (category.name === "Employee Award MCG Employee of the Year") {
          link = '/my-profile/review-nomination-mcg-employee-award/' + id
        }        
        console.log(' category ', category, link)
      });
      if (this.type === 'received') {
      
          link = link+'/received'
      }
      return link
    },
    getLinkURI: function() {
      WordpressRestAPI.getViewContent('pdfCard/' + this.id )
        .then(response => {
            this.linkHigh5 = response.data
        })
        .catch(function (error) {
            console.error(error)
        })
    }
  }
}
</script>

<style lang="less">
  .listLink {
    &::after {
      content: ', '
    }
    &:last-child {
      &::after {
        content: ''
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Nomination.vue